import { wheelPriceParamName } from "../../../Wheels/Filters/WheelPrice/useWheelPrice";
import { tireBrandsParamName } from "./TireBrandFilters/useTireBrands";
import { tireLoadRatingParamName } from "./TireLoadRaitingFilters/useTireLoadRating";
import { useTirePLYRatingParamName } from "./TirePlyRaitingFilters/useTirePLYRating";
import { useTirePricingParamName } from "./TirePriceFilters/useTirePricing";
import { useSpeedIndexParamName } from "./TireSpeedIndexFilters/useSpeedIndex";

export const secondaryTireFilters = [
  tireBrandsParamName,
  tireLoadRatingParamName,
  useTirePLYRatingParamName,
  useTirePricingParamName,
  useSpeedIndexParamName,
  wheelPriceParamName,
];

/**
 * @see docs/worklog/TW-859-combos-wheel-filters/rfc.md
 * @see docs/worklog/TW-859-combos-wheel-filters/tfc.md
 */
